<template>
  <div>
    <div
      class="fill-height d-flex align-center hover-item px-2 "
      style="height: 50px"
      @click="$emit('rowClicked', cls)"
      :class="selectRelay ? 'selected-item' : null"
    >

      <div class="pl-2">
        <v-btn
          icon
          class="pa-0 ma-0"
          :color="selected ? 'primary' : 'grey darken-2'"
          @click.stop="selectRelay = !selectRelay;"
        >
          <v-icon>{{selectRelay ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon>
        </v-btn>

      </div>

      <div class="pl-2">
        <v-icon :color="labelsRef[cls.defaultLabel].color">{{labelsRef[cls.defaultLabel].icon}}</v-icon>
      </div>

      <div class="body-1 px-2 flex-grow-1 flex-equal d-flex align-center" @click="test">
        <app-icon :match="cls.match" left small/>
        {{cls.title}}<span v-if="cls.alias" class="caption grey--text">&nbsp;({{cls.match}})</span>
        <v-tooltip top v-if="cls.aiAssigned">
          <template v-slot:activator="{on}">
            <v-icon right small v-on="on" color="blue">mdi-lightbulb-auto-outline</v-icon>
          </template>
          <div style="max-width: 300px">
            AI Auto Assigned
            <br>
            <span class="text-caption">
                {{cls.aiReason}}
              </span>
          
          </div>
        </v-tooltip>
      </div>

      <div class="body-1 px-2 flex-grow-1 flex-equal d-flex align-center">
        {{cls.totalDuration ? durationDisplay(cls.totalDuration) : 'Not Used'}}
      </div>

      <div
        class="body-1 px-2 d-flex align-center"
        :class="manualTimeTab ? 'justify-start' : 'flex-shrink-1 flex-equal'"
        :style="manualTimeTab ? 'flex: 0 0 200px; width: 200px;' : null"
      >
        <a v-if="isValidUrl(cls.match)" @click.stop="() => {}" :href="`https://${cls.match}`" target="_blank" style="text-decoration: none; width: 120px">
          <v-btn
            small
            text
            color="primary"
          >
            Goto Site
            <v-icon right>mdi-arrow-top-right</v-icon>
          </v-btn>
        </a>
        <v-tooltip top v-else-if="manualTimeTab && cls.manualTimeTeamIds && cls.manualTimeTeamIds.length">
          <template v-slot:activator="{on}">
            <div v-on="on" class="d-inline-block" style="white-space: nowrap;">
              <app-outlined-chip
                :label="`Limited to ${cls.manualTimeTeamIds.length} Team${cls.manualTimeTeamIds.length > 1 ? 's' : ''}`"
                color="secondary"
                icon="mdi-account-group"
              />
            </div>
          </template>
          <div style="max-width: 300px">
            Only employees in these teams can see and log this option:
            <br>
            <span class="text-caption">{{ limitedTeamNames }}</span>
          </div>
        </v-tooltip>
      </div>

      <div class="d-flex align-center flex-grow-1 flex-equal justify-end">
        <div class="px-2">
          <app-outlined-chip
            v-if="cls.teamLabels && cls.teamLabels.length"
            :label="`${cls.teamLabels.length} Team Rule${cls.teamLabels.length > 1 ? 's' : ''}`"
            color="secondary"
            icon="mdi-account-group"
          />
        </div>
        <div class="px-2" style="width: 200px">
          <v-card
            class="pl-4 pr-2"
            hover
            ripple
            @click.stop="dropdownClicked"
            ref="dropdown"
            style="position: relative"
          >
            <div class="d-flex align-center">
              <div class="flex-grow-1 body-2 py-2">
                {{ labelsRef[cls.defaultLabel].text }}
              </div>
              <v-icon right>mdi-chevron-down</v-icon>
            </div>
            <v-progress-linear absolute indeterminate v-if="loading"/>
          </v-card>
        </div>
        <div class="pl-2" v-if="cls.manualTime">
          <v-btn
            icon
            :loading="loading"
            @click.stop="!loading ? $emit('editClicked', cls) : null"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </div>
        <div class="pl-2">
          <v-btn
            :disabled="!showMore"
            icon
            :loading="loading"
            @click.stop="!loading ? $emit('moreClicked', cls) : null"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
import {StatusMap} from "@/models/statusMap";
import AppOutlinedChip from "@/components/Shared/AppOutlinedChip";
import {mapGetters} from "vuex";
import {durationDisplay, isValidUrl} from "@/core/codeFunctions";
import AppIcon from "@/components/Shared/AppIcon";
export default {
  components: {AppIcon, AppOutlinedChip},
  props: {
    cls: StatusMap,
    loading: {
      type: Boolean,
      default: false,
    },
    selected: Boolean,
    showMore: Boolean,
    manualTimeTab: Boolean
  },
  data() {
    return {
      durationDisplay: durationDisplay,
      con: console,
      isValidUrl: isValidUrl
    }
  },
  methods: {
    dropdownClicked() {
      if (!this.loading)
        this.$emit('dropdownClicked', {component: this.$refs.dropdown, value: this.cls})
    },
    
    test() {
      console.log(this.cls)
    }
  },
  computed: {
    ...mapGetters(['labelsRef', 'teamsRef']),
    limitedTeamNames() {
      return (this.cls.manualTimeTeamIds || [])
        .map(teamId => (this.teamsRef[teamId] || {}).name)
        .filter(Boolean)
        .join(', ')
    },
    selectRelay: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit('selected', val)
      }
    }
  },
}
</script>

<style scoped>

</style>